import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const CustomTemplate = lazy(() =>
  import("../layouts/custom").then((m) => ({ default: m.CustomTemplate }))
);

interface AppSearch {
  preview: boolean;
}

export const Route = createFileRoute("/app")({
  validateSearch: (search: Record<string, unknown>): AppSearch => ({
    preview: search.preview === "1" || search.preview === true,
  }),
  component: AppRoute,
});

function AppRoute() {
  const { preview } = Route.useSearch();
  return (
    <Suspense fallback={null}>
      <CustomTemplate previewMode={preview} />
    </Suspense>
  );
}
